
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"62","height":"62","viewBox":"0 0 72 72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"opacity":"0.14","cx":"36.0002","cy":"36.0002","r":"33.3239","stroke":"#F3F0FF","stroke-width":"4"}}),_c('path',{attrs:{"d":"M69.7337 36.1599C69.7337 41.4318 68.4863 46.6296 66.0925 51.3325C63.6986 56.0353 60.2257 60.111 55.9548 63.2295C51.6839 66.348 46.7351 68.4217 41.5092 69.2827C36.2833 70.1436 30.9271 69.7676 25.8744 68.185C20.8217 66.6025 16.2144 63.858 12.4256 60.1737C8.63688 56.4893 5.77314 51.9688 4.06632 46.9781C2.35949 41.9873 1.85754 36.6667 2.60111 31.447C3.34469 26.2273 5.31288 21.2552 8.34633 16.9333","stroke":"url(#paint0_linear)","stroke-width":"4","stroke-linecap":"round"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"36.0004","y1":"16.9333","x2":"36.0004","y2":"69.7333","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#6E47FF"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#9F7AFD"}})])])])
          )
        }
      }
    